import styled from "styled-components";

export const MiniLineChart = styled.div`
  padding: 0px;
  width: 100px;
  height: 50px;
`;
